module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "hantao.3994b21c.jpg";